import { useQuery, UseQueryResult } from "@tanstack/react-query"
import { trpcRetry } from "#/lib/trpc/retryPolicy"
import ResponseError from "#/types/responseError"
import { trpc } from "#/lib/trpc/client"

export type ProviderCount = {
  hasFertilityProviders: boolean
  hasUrologyProviders: boolean
  hasAdoptionProviders: boolean
  hasCryobanksProviders: boolean
  hasLowTProviders: boolean
  hasMenopauseProviders: boolean
  hasGenderAffirmingHormoneTherapyProviders: boolean
  hasDonorAssistedReproductionProviders: boolean
  hasGestationalCarrierProviders: boolean
  hasPelvicFloorTherapyProviders: boolean
  hasDoulasProviders: boolean
  hasProviders: boolean
}

const HAS_PROVIDER_TYPE_IN_COUNTRY_QUERY_KEY = "GetHasProviderTypeInCountry"

export function useGetHasProviderTypeInCountry(countryCode: string): UseQueryResult<ProviderCount, ResponseError> {
  return useQuery<ProviderCount, ResponseError>(
    [HAS_PROVIDER_TYPE_IN_COUNTRY_QUERY_KEY, countryCode],
    () => trpc.member.hasTypesInCountry.query({ countryCode }),
    {
      refetchOnWindowFocus: false,
      retry: trpcRetry(1)
    }
  )
}
